import { SupportedResolution } from '../types';

export const ResolutionInSeconds: Record<SupportedResolution, number> = {
  '1': 60,
  '5': 60 * 5,
  '15': 60 * 15,
  '60': 60 * 60,
  '240': 60 * 60 * 4,
  '1D': 60 * 60 * 24,
  '1W': 60 * 60 * 24 * 7,
};
